import React from 'react';
import Review from './review';
import '../css/Service.css';

function MedicalWaste() {
  return (
    <div className="service-page">
      <div className="service-banner">
        <img src="/img_1.jpg" alt="Medical Waste Banner" className="service-banner-img" />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Medical Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>MEDICAL WASTE MANAGEMENT</h1>
        <p>We provide medical waste management services to a wide range of healthcare and related facilities.</p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>We provide medical waste management services to:</h2>
          <ol className="feature-list">
            <li>Hospitals</li>
            <li>Health care centers</li>
            <li>Dental clinics</li>
            <li>Blood banks</li>
            <li>Veterinary clinics</li>
            <li>Laboratories</li>
            <li>Cancer centers</li>
            <li>Dialysis centers</li>
            <li>Any location that produces biological waste streams</li>
          </ol>

          <h3>Medical waste streams include:</h3>
          <ol className="feature-list">
            <li>Human blood and blood products — blood that can be poured, dripped, or flaked off of materials/tools</li>
            <li>Pathological waste (human or animal organs, tissues, or body parts intended for disposal)</li>
            <li>Contaminated sharps</li>
            <li>Uncontaminated sharps</li>
            <li>Pharmaceutical waste</li>
            <li>Isolation waste-stream (common in assisted living facilities)</li>
            <li>Cultures and stocks of infectious agents (microbiological waste)</li>
            <li>Contaminated animal carcasses, body parts, and bedding</li>
          </ol>

          <p>
            Our team handles collection, packaging, transportation, and compliant disposal or treatment of regulated medical waste. We provide documentation and manifesting for regulated streams and can tailor service schedules to match your generator status.
          </p>

          <div className="service-cta">
            <a href="/contact" className="btn btn-primary">Request Medical Waste Pickup</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="specialty-card">
            <h3>Why choose us?</h3>
            <ul className="specialty-list">
              <li>Regulatory-compliant handling and transport</li>
              <li>Documented chain-of-custody and reporting</li>
              <li>Flexible pickup schedules</li>
              <li>Nationwide coverage and experienced staff</li>
            </ul>
          </div>
        </aside>

      </section>

      <Review />
    </div>
  );
}

export default MedicalWaste;
